var documentWidth = $(document).width();
$(window).resize(function () {
  documentWidth = $(document).width();
});

$(function () {
  // close auto complete
  $(".js-tour-booking").delegate(
    ".js-close-auto-complete",
    "click",
    function () {
      $(".js-tour-booking-input").autocomplete("close");
      $(".js-autocomplete-list>ul").hide();
      $("html").removeClass("no-scroll");
      $(".js-tour-booking-item").removeClass("show-mobile");
    },
  );

  // close auto complete list when click in out of it
  $(document).click(function (e) {
    if ($(e.target).closest("js-tour-booking").length === 0) {
      $(".js-autocomplete-list").removeClass("show");
      $(".js-autocomplete-field").removeClass("open");
    }
  });

  // module four column tours hover effect
  $(".four-column-tours__content .four-column-tours__card").each(function () {
    $(this).hover(
      function () {
        $(this).siblings().addClass("small");
        $(this).addClass("active");
      },
      function () {
        $(this).siblings().removeClass("small");
        $(this).removeClass("active");
      },
    );
  });

  // update auto complete after type
  function getResult(input) {
    var dataUrl = "/v2/tour/search/";
    if ($(input).val()) {
      dataUrl += $(input).val();
    }
    return dataUrl;
  }

  $(".js-tour-booking-input").each(function (e) {
    $(this)
      .autocomplete({
        minLength: 0,
        source: function (request, response) {
          if (request.term === "" && window.tourDefaultList) {
            response(window.tourDefaultList);
          } else {
            var url = getResult($(".js-tour-booking-input"));

            $.getJSON(`${url}/`).done(function (serverResponse) {
              response(serverResponse.model);
            });
          }
        },
        appendTo: $(this).next(),
        search: function () {
          $(this).closest(".js-tour-booking-item").addClass("show-mobile");

          if (documentWidth < 992) {
            $("html").addClass("no-scroll");
          }
        },
      select: function (event, ui) {
  $(this).val(ui.item.title);
  $(this).attr("placeholder", ui.item.title);

  tourLocalStorage(ui.item.href, ui.item.title);
  $(".js-tour-booking-item").removeClass("show-mobile");
  window.location = ui.item.href;

  return false;
},
        focus: function (e, ui) {
          $(".js-tour-booking-input").attr("placeholder", "");
          setTimeout(function () {
            $(".js-tour-booking-input").val(ui.item.title);
          }, 1);
        },
        close: function (e, ui) {
          $(".js-tour-booking-input").attr("placeholder", "مقصد کجاست؟");

          $(".js-tour-booking-item").removeClass("show-mobile");

          $("html").removeClass("no-scroll");
        },
      })
      .bind("focus", function () {
        $(this).keydown();
      })

      .keydown(function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          if (
            $(".ui-autocomplete:visible").length &&
            $(".ui-autocomplete li.ui-menu-item").length
          ) {
            var firstItem = $(".ui-autocomplete li.ui-menu-item:first-child a");
            tourLocalStorage(firstItem.attr("href"), firstItem.text());
            if (firstItem) window.location = firstItem.attr("href");
          }
        }
      })

      .autocomplete("instance")._renderItem = function (ul, item) {
      var iconClass;
      iconClass = "icon-map";

      return $("<li>")
        .append(
          "<a href='" +
            item.href +
            "' onclick=\"ga('send', 'event', 'FirstPage', 'SearchItem', '" +
            item.title +
            '\')" class="tourSlug" > <i class=\'' +
            iconClass +
            "'></i> <span>" +
            item.title +
            "</span></a>",
        )
        .appendTo(ul);
    };
  });
});

function tourLocalStorage(url, title) {
  var localStorageKey = `${window.prefixSearchHistory}-offline-${
    $(".js-search-holder-landing").attr("id") ||
    $(".js-tab-nav").find(".js-tab-content>div.active").attr("id")
  }`;
  var searchHistoryItem = {
    value: {
      href: url,
      title: title,
      tourType: "offline",
    },
    baseUrl: url,
    expire: moment().add(1, "months").format("YYYY-MM-DD"),
  };

  window.updateLocalStorage(localStorageKey, searchHistoryItem);
}
